import React from 'react'
import { CountryProvider } from './CountryProvider'
import { QAPermissionsProvider } from './PermissionsProvider'
import { QASponsorLevelProvider } from './SponsorLevelProvider'

// TimeTravelProvider used to live here, but MyScheduleProvider reads the clock and mounts above this
// block, so it never saw the offset. It's in the AppProviders list now. Don't add a second one here:
// each provider owns its own offset, so TimeSelector would write this one while MyScheduleProvider
// kept reading the outer one.
const QualityAssuranceProviders = ({ children }) => {
  return (
    <CountryProvider>
      <QAPermissionsProvider>
        <QASponsorLevelProvider>{children}</QASponsorLevelProvider>
      </QAPermissionsProvider>
    </CountryProvider>
  )
}

export default QualityAssuranceProviders
